var render = function (_h,_vm) {var _c=_vm._c;return _c('ebx-default-rating',_vm._b({staticClass:"ebx-result-rating",class:[].concat(_vm.data.staticClass, _vm.data.class),style:(_vm.data.style),attrs:{"value":_vm.props.item.rating.value}},'ebx-default-rating',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }